import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private baseUrl:string = `${environment.legalAssureApiBaseUrl}`;

  constructor(private httpClient:HttpClient) { }

  createUser(request:any){
    return this.httpClient.post<any[]>(this.baseUrl+'Auth/register',request);

  }

  getAllUsers(isActiveUser:boolean): Observable<any> {
   let headersOptions = new HttpHeaders();
   headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any>(this.baseUrl+`user?isActiveUser=${isActiveUser}`,{headers:headersOptions});
  }

  deleteById(data:any){
    return this.httpClient.delete<any[]>(this.baseUrl+`user/${data}`);
  }

  getById(data:any){
    return this.httpClient.get<any>(this.baseUrl+`user/${data}`);
  }
  update(request:any){
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put<any[]>(this.baseUrl+'user',request);
  }
  login(request:any){
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.baseUrl+'User/Login',request);
  }

  getRoles(){
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any>(this.baseUrl+'User/Roles');
  }
}
